__webpack_require__.p = "/cringe-speak/";